import '../../api/Admin/methods';
import '../../api/Admin/server/publications';

import '../../api/App/server/publications';
import '../../api/App/methods';

import '../../api/Projects/methods';
import '../../api/Projects/server/publications';

import '../../api/Videos/methods';
import '../../api/Videos/server/publications';

import '../../api/Users/server/methods';
import '../../api/Users/server/publications';

import '../../api/OAuth/server/methods';

import '../../api/Annotations/methods';
import '../../api/Annotations/server/publications';

import '../../api/AnnotationTemplates/methods';
import '../../api/AnnotationTemplates/server/publications';

import '../../api/Missions/methods';
import '../../api/Missions/server/publications';

import '../../api/Styles/methods';
import '../../api/Styles/server/publications';

import '../../api/Layers/methods';
import '../../api/Layers/server/publications';

import '../../api/Maps/methods';
import '../../api/Maps/server/publications';

import '../../api/TelemetryConnections/server/publications';
import '../../api/TelemetryConnections/methods';

import '../../api/Connectors/methods';
import '../../api/Connectors/server/publications';

import '../../api/UserControl/server/publications';
